
import debug from '../qa/debug';

/* */

const trackingApi = {};

trackingApi.sendPageImpressionTrackingRequest = (payload, eventMergeId) => {
    if (payload) {
        if (eventMergeId) {
            otto.tracking.submitEventMerge(eventMergeId, payload);
        } else {
            otto.tracking.submitMerge(payload);
        }
        debug.log('send page impression tracking request', payload);
    }
};

trackingApi.sendFeatureTrackingRequest = (payload) => {
    if (payload) {
        otto.tracking.submitMerge({}, payload)
        debug.log('send feature tracking request', payload);
    }
};

trackingApi.sendFeatureTrackingMoveAction = (baseLabelPayload, featurePayload) => {
    if (baseLabelPayload && featurePayload) {
        otto.tracking.submitMove(baseLabelPayload, featurePayload)
        debug.log('send feature tracking move action', featurePayload);
    }
};

trackingApi.sendFeatureTrackingScrollAction = (baseLabelPayload, payload) => {
    if (baseLabelPayload && payload) {
        otto.tracking.submitEvent(baseLabelPayload, payload);
        debug.log('send feature tracking action', payload);
    }
};

export default trackingApi;
